import { useContext, useEffect } from "react";
import VehicleConnectionPopup from "../../../Vehicles/VehiclePopUp/VehicleConnectionPopup";
import UsersConnectionPopup from "../../../Users/UsersPopUp/UsersConnectionPopup";
import { popupcontext } from "../../../../context/Popupscontext";
export default function Link() {
	const { isLinking, setIsLinking, activeConnection } =
		useContext(popupcontext);
	useEffect(() => {
		if (isLinking && activeConnection?.id) {
		}
	}, []);
	console.log("Activeoopt", activeConnection?.imei);
	if (!isLinking || !activeConnection?.id) return null;

	if (activeConnection.type === "vehicles") {
		return (
			<VehicleConnectionPopup
				key={activeConnection.id}
				name={activeConnection.name}
				vehicleId={activeConnection.id}
				imei={activeConnection?.imei}
				setIsLinking={setIsLinking}
			/>
		);
	}

	if (["users", "subusers"].includes(activeConnection.type)) {
		return (
			<UsersConnectionPopup
				key={activeConnection.id}
				name={activeConnection.name}
				userId={activeConnection.id}
				setIsLinking={setIsLinking}
				role={activeConnection.role}
			/>
		);
	}

	return null;
}
